// Central smooth-scroll helper that respects the Lenis instance
export const scrollToId = (id) => {
  const selector = id.startsWith("#") ? id : `#${id}`;
  const el = document.querySelector(selector);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(el, { offset: -10, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToTop = () => {
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(0, { duration: 1.2 });
  else window.scrollTo({ top: 0, behavior: "smooth" });
};
